export default __webpack_public_path__ + "static/MediaMainBannerMobile-95a3ffee3700fbb33a486a41dec69038.webp";